import { IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const DrawerButtonThatOpens = ({ open, name, subTitle, children, ...rest }) => {
    if (open) {
        if (name === "") {
            return (
                <DrawerButtonOpen {...rest}>
                    {children}
                </DrawerButtonOpen>
            )
        }
        return (
            <DrawerButtonOpen {...rest}
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "8px 20px"
                }}>
                {children}
                <Typography>
                    {name} {(subTitle) && (<small style={{ display: "block", textAlign: "right" }}>{subTitle}</small>)}
                </Typography>
            </DrawerButtonOpen>
        )
    } else {
        return (
            <DrawerButtonClosed {...rest}>
                {children}
            </DrawerButtonClosed>
        )
    }
}

const DrawerButtonOpen = styled(IconButton)(
    ({ theme }) => ({
        backgroundColor: "#6E6E6E",
        color: "#fff",
        borderRadius: "10px",
        '&:hover': {
            background: 'transparent linear-gradient(79deg, #6D79EC 0%, #8166F5 100%) 0% 0% no-repeat padding-box;',
            color: '#FFFFFF',
            boxShadow: 'none',
        },
        '&:disabled': {
            background: "#6E6E6E",
            color: "#3f3f3f"
        }
    })
);

const DrawerButtonClosed = styled(IconButton)(
    ({ theme }) => ({
        borderRadius: "10px",
        color: "#fff",
        backgroundColor: "#6E6E6E",
        '&:hover': {
            background: 'transparent linear-gradient(79deg, #6D79EC 0%, #8166F5 100%) 0% 0% no-repeat padding-box;',
            color: '#FFFFFF',
            boxShadow: 'none',
        }
    })
);

export default DrawerButtonThatOpens;